var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6273 24 24 18.6273 24 12C24 5.37269 18.6273 0 12 0C5.37269 0 0 5.37269 0 12C0 18.6273 5.37269 24 12 24Z",
    fill: "#24A980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4896 13.1961L12.0234 13.2348C11.2515 13.2348 10.7307 13.2154 10.5376 13.1961C7.62448 13.0803 5.42503 12.5594 5.42503 11.9614C5.42503 11.344 7.60517 10.8425 10.5376 10.7073V12.6943C10.7307 12.7137 11.2708 12.733 12.0424 12.733C12.9492 12.733 13.4123 12.6943 13.4896 12.6943V10.7073C16.422 10.8425 18.6021 11.344 18.6021 11.9614C18.6021 12.5594 16.422 13.0803 13.4896 13.1961ZM13.4896 10.4952V8.72028H17.5795V6H6.46697V8.72028H10.5569V10.4952C7.23855 10.6494 4.75 11.3054 4.75 12.0966C4.75 12.8877 7.23855 13.5434 10.5569 13.6979V19.4086H13.5089V13.6977C16.827 13.5434 19.3158 12.8874 19.3158 12.0963C19.2965 11.3054 16.8079 10.6494 13.4896 10.4949V10.4952Z",
    fill: "#FFFDFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.5169de75e6e78b09a1ca9f54fa82f7f3.svg";
export { ForwardRef as ReactComponent };